import classNames from 'classnames/bind';

export default classNames;
